/*
 * Ce fichier assure la sécurité des liens ouverts dans un nouvel onglet
 * en ajoutant automatiquement les attributs rel="noopener noreferrer"
 * pour éviter les attaques de type reverse tabnabbing.
 */

document.addEventListener(
    'click',
    (event) => {
        const link = event.target.closest?.('a[target="_blank"]');
        if (!link) return;

        let url;
        try {
            url = new URL(link.href, window.location.href);
        } catch {
            return;
        }

        if (/^https?:$/.test(url.protocol) && url.hostname !== window.location.hostname) {
            link.relList.add('noopener', 'noreferrer');
        }
    },
    true,
);
